import apiService from '@/api/apiService';

export const getAdminMe = async (accessToken = null) => {
    const url = '/api/admin/me';
    const headers = {};
    if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
    }
    return apiService.GET(url, {}, headers);
};
